import { getItemFromCollection } from "directus/src/operations";

export async function fetchTagData({ tagId }) {
  try {
    const response = await getItemFromCollection("tags", tagId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
